
function NotFound() {
  return (
    <div style={{ 
      textAlign: "center", 
      padding: "50px 20px", 
      fontFamily: "sans-serif" 
    }}>
      <h1 style={{ fontSize: "80px", margin: "0" }}>404</h1>
      <h2>ไม่พบหน้าที่คุณต้องการ</h2>
      <p>หน้าที่คุณค้นหาไม่มีอยู่ในระบบ</p>
    </div>
  );
}

export default NotFound;